module.exports = "pegasus/assets/background-patterns/iron-grip.png";